import { render, staticRenderFns } from "./EditorialBoard.vue?vue&type=template&id=77b71942"
import script from "./EditorialBoard.vue?vue&type=script&lang=js"
export * from "./EditorialBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports